import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"align-items":"center","display":"flex","justify-content":"center"},
  class: "mt-2"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "text-body-2 text-subtitle" }
const _hoisted_4 = { class: "ml-2" }
const _hoisted_5 = ["onClick"]

import configuration from '@/composables/config';
import { useSearchCompany } from '@/composables/companies';
import { useCompanyStore } from '@/store/companies';
import { useUserStore } from '@/store/user';
import { ref, watch, withDefaults } from 'vue';
import _ from 'lodash';
import { Company, CompanyEmployeeRole } from '@/graphql/types/graphql';
import { useI18n } from 'vue-i18n';

interface CompanySelectorProps {
    isOnboarding: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanySelector',
  props: {
    isOnboarding: { type: Boolean, default: false }
  },
  emits: ['select', 'write', 'selectRole'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();

let companyRoles = Object.values(CompanyEmployeeRole).filter(
    (el) => el !== CompanyEmployeeRole.Admin
);

const roles = companyRoles.map((el) => ({
    label: t((el as string).toLowerCase()),
    value: el,
}));

const roleList = roles.map((el) => el.label);

const emit = __emit;

const companyStore = useCompanyStore();
const userStore = useUserStore();
const companyName = ref('');
const selectedCompany = ref(null);
const selectedRole = ref(null);

const userCompaniesId = userStore.allCompanies
    ? userStore.allCompanies.map((el) => el.companyId)
    : [];

watch(companyName, (value) => {
    if (_.isString(value)) {
        if (value.length >= 3) {
            searchCompany(value);
        }
    } else {
        companyStore.companies = null;
        selectCompany(null);
    }
    emit('write', value);
});

watch(selectedRole, (value) => {
    const role = roles.find((el) => (el as any).label === value);
    emit('selectRole', role.value);
});

function selectCompany(company) {
    selectedCompany.value = company;
    if (company) {
        companyName.value = company.name;
    }

    emit('select', company);
}

function searchCompany(text: string) {
    const { result, loading, onError } = useSearchCompany({ text });
    companyStore.loading = true;
    watch(result, (data) => {
        if (data && data.CompanySearch) {
            companyStore.companies = data.CompanySearch.filter(
                (c) => !userCompaniesId.includes(c.id)
            ) as Company[];
        } else {
            companyStore.companies = null;
        }
        companyStore.loading = loading.value;
    });

    onError((result) => {
        console.error(result.message);
        companyStore.loading = loading.value;
    });
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_text_field, {
      modelValue: companyName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((companyName).value = $event)),
      label: `${_ctx.$t('name')} *`,
      class: "mt-4",
      variant: "underlined",
      "hide-details": "",
      color: "primary"
    }, null, 8, ["modelValue", "label"]),
    (_unref(companyStore).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : _createCommentVNode("", true),
    (
                _unref(companyStore).companies &&
                _unref(companyStore).companies.length > 0 &&
                companyName.value &&
                companyName.value.length > 0
            )
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_card, {
            class: "pa-2 mt-4",
            elevation: "0",
            variant: "outlined",
            color: "gray"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('other_companies_message')), 1),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(companyStore).companies, (c) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: c.id,
                    class: "text-primary text-body-2 mt-2",
                    onClick: ($event: any) => (selectCompany(c))
                  }, [
                    _createTextVNode(_toDisplayString(c.name) + " ", 1),
                    (selectedCompany.value && selectedCompany.value.id == c.id)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" mdi-check ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_5))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (selectedCompany.value)
      ? (_openBlock(), _createBlock(_component_v_select, {
          key: 2,
          modelValue: selectedRole.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedRole).value = $event)),
          items: _unref(roleList),
          class: "mt-8 mb-8",
          label: _ctx.$t('role'),
          variant: "underlined",
          "hide-details": "",
          color: "primary"
        }, null, 8, ["modelValue", "items", "label"]))
      : _createCommentVNode("", true)
  ]))
}
}

})